var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcons40NewBook1X(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M38 20C38 10.0589 29.9411 2 20 2C10.0589 2 2 10.0589 2 20C2 29.9411 10.0589 38 20 38C29.9411 38 38 29.9411 38 20ZM4.25 20C4.25 11.3015 11.3015 4.25 20 4.25C28.6985 4.25 35.75 11.3015 35.75 20C35.75 28.6985 28.6985 35.75 20 35.75C11.3015 35.75 4.25 28.6985 4.25 20ZM24.7453 13.4686L20 6.5L15.2547 13.4686L7.16074 15.8283L12.3219 22.4948L12.0649 30.9217L20 28.0732L27.9351 30.9217L27.6781 22.4948L32.8393 15.8283L24.7453 13.4686ZM20 10.4969L23.3402 15.4026L29.0369 17.0633L25.4045 21.756L25.5845 27.6878L20 25.6826L14.4146 27.6878L14.5955 21.756L10.9622 17.0633L16.6598 15.4026L20 10.4969Z",
    id: "path_1"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    id: "artboard_1"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip_1"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#artboard_1",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "mask_1"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path_1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons40new_book",
    clipPath: "url(#clip_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38 20C38 10.0589 29.9411 2 20 2C10.0589 2 2 10.0589 2 20C2 29.9411 10.0589 38 20 38C29.9411 38 38 29.9411 38 20ZM4.25 20C4.25 11.3015 11.3015 4.25 20 4.25C28.6985 4.25 35.75 11.3015 35.75 20C35.75 28.6985 28.6985 35.75 20 35.75C11.3015 35.75 4.25 28.6985 4.25 20ZM24.7453 13.4686L20 6.5L15.2547 13.4686L7.16074 15.8283L12.3219 22.4948L12.0649 30.9217L20 28.0732L27.9351 30.9217L27.6781 22.4948L32.8393 15.8283L24.7453 13.4686ZM20 10.4969L23.3402 15.4026L29.0369 17.0633L25.4045 21.756L25.5845 27.6878L20 25.6826L14.4146 27.6878L14.5955 21.756L10.9622 17.0633L16.6598 15.4026L20 10.4969Z",
    id: "Combined-Shape",
    fill: "#9DC92A",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#mask_1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "coloursecondarylightCyan+75"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0L40 0L40 40L0 40L0 0Z",
    id: "Rectangle-Copy-7",
    fill: "#47D5CD",
    fillRule: "evenodd",
    stroke: "none"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons40NewBook1X);
export default __webpack_public_path__ + "static/media/icons40new_book@1x.25977e50fbe6ed2be3d191f067fa5762.svg";
export { ForwardRef as ReactComponent };